import React, { useEffect, useState } from "react"

const Timeline = ({ counter, widthCol, propsTimelines }) => {
  const [visibility, setVisibility] = useState(false)

  const { hoursNowComp, minutesNowComp, emPosition, extraMinutes, isDesktopLarge, isDesktopNormal } = propsTimelines
  let numberTimes = 3
  isDesktopLarge && (numberTimes = 4)
  
  const setTimeline = () => {
    const timeline = document.querySelector('.time-line')
    const diffAdd = (emPosition - counter) * widthCol
    const diffMinutesAdd = (widthCol / 30) * extraMinutes
    const finalAdd = diffAdd + diffMinutesAdd
    timeline.style.left = 216 + finalAdd + 'px'
  }

  useEffect(() => {
    visibility ?
      ((counter > emPosition - numberTimes) && (counter < emPosition + 1)) ? setTimeline() : setVisibility(false)
      :
      ((counter > emPosition - numberTimes) && (counter < emPosition + 1)) && setVisibility(true)
  }, [counter])

  useEffect(() => {
    visibility && setTimeline()
  }, [visibility])
  
  let styleTimeline = {
    left: '216px',
    opacity: 0
  }
  if (visibility && isDesktopNormal) {
    styleTimeline = {
      left: '216px',
      opacity: 1
    }
  }
  
  return (
    <>
      <div className="time-line" style={styleTimeline}>
        <p>{hoursNowComp}:{minutesNowComp}</p>
      </div>
    </>
  )
}

export default React.memo(Timeline)